import React from "react";
import classNames from "classnames/bind";

import { Screen } from "../../components/Screen";
import { ScreenMiratorg } from "../../components/ScreenMiratorg";

import { useStateManager } from "utils/useStateManager";
import { saveOrPrintBlob } from "utils/saveOrPrintBlob";
import { RationItem } from "types/Data";

import styles from "./Product.module.css";

const cx = classNames.bind(styles);

type Props = {
  onSubmit: (exists?: boolean) => void;
  showProducts: boolean | undefined;
  miratorgData?: {
    additional_text: string;
    button_lable: string;
    button_url?: string;
  };
  showDownloadButton: boolean | undefined,
  showEmailButton: boolean | undefined
};

export const Product: React.FC<Props> = ({
  onSubmit,
  showProducts,
  miratorgData,
  showDownloadButton,
  showEmailButton
}) => {
  const { blob, parsedSelftestData, isLoading, setIsLoading } =
    useStateManager();

  const renderItem = (item: RationItem, index: number) => {
    const { supplements } = parsedSelftestData;
    const supplement = supplements.find(
      (supplement) => supplement.key === item.custom_бад.key
    );
    const image = supplement?.custom_картинка_url;
    const configByType = {
      1: "таб.",
      2: "капс.",
      3: "држ.",
      4: "грнл.",
      5: "гр.",
      6: "сут. дз",
      7: "пкт.",
    };
    const units = supplement
      ? configByType[supplement.custom_лекарственная_форма.value]
      : "";
    const size = supplement?.custom_объем_упаковки || 1;
    const packages = Math.ceil((item.custom_порций * item.custom_курс) / size);

    return (
      <div className={cx("product")}>
        <div
          className={cx("product_header")}
          style={{ paddingBottom: image ? "16px" : "38px" }}
        >
          <p className={cx("product_title")}>
            <a
              href={supplement?.custom_ссылка}
              target="_blank"
              rel="noreferrer"
            >
              {item.custom_бад.label}
            </a>
          </p>
          {image && <img className={cx("product_image")} src={image} alt="" />}
        </div>
        <div className={cx("product_info")}>
          <div className={cx("product_portions")}>
            <p>
              {item.custom_порций} {units}
              <br />
              <span>в сутки</span>
            </p>
          </div>
          <div className={cx("product_course")}>
            <p>
              {item.custom_курс}
              <br />
              <span>курс, суток</span>
            </p>
          </div>
          <div className={cx("product_packages")}>
            <p>
              {packages}
              <br />
              <span>уп. на курс</span>
            </p>
          </div>
          <a href={supplement?.custom_ссылка} target="_blank" rel="noreferrer">
            <div className={cx("product_cart")}>
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M1 0C0.447715 0 0 0.447715 0 1C0 1.55228 0.447715 2 1 2H3.18861L5.02145 10.706L5.22295 11.6631L6.18429 11.4829L13.5356 10.1045C14.3225 9.95695 14.9457 9.35425 15.1194 8.57262L15.9762 4.71693C16.042 4.42083 15.9698 4.11088 15.78 3.87427C15.5902 3.63767 15.3033 3.5 15 3.5H5.54824L4.97855 0.79399L4.81139 0H4H1ZM6.77705 9.33688L5.96929 5.5H13.7534L13.167 8.13876L6.77705 9.33688ZM5 16C6.10457 16 7 15.1046 7 14C7 12.8954 6.10457 12 5 12C3.89543 12 3 12.8954 3 14C3 15.1046 3.89543 16 5 16ZM12 16C13.1046 16 14 15.1046 14 14C14 12.8954 13.1046 12 12 12C10.8954 12 10 12.8954 10 14C10 15.1046 10.8954 16 12 16Z"
                  fill="var(--base_blue)"
                />
              </svg>
            </div>
          </a>
        </div>
      </div>
    );
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault()
    onSubmit()
  };

  const downloadPdfHandler = async() => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 500);

    try {
      await saveOrPrintBlob(blob);
      onSubmit();
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <>
      {miratorgData ? (
        <ScreenMiratorg
          title={showProducts ? "Рекомендуемая продукция" : "Отчёт готов"}
          isLoading={isLoading}
          onSubmit={handleSubmit}
          miratorgData={miratorgData}
          showEmailButton={showEmailButton}
          showDownloadButton={showDownloadButton}
          downloadPdfHandler={downloadPdfHandler}
        />
      ) : (
        <Screen
          title={showProducts ? "Рекомендуемая продукция" : "Отчёт готов"}
          isLoading={isLoading}
          onSubmit={handleSubmit}
          withoutProducts={!showProducts}
          showEmailButton={showEmailButton}
          showDownloadButton={showDownloadButton}
          downloadPdfHandler={downloadPdfHandler}
        >
          {showProducts && (
            <>
              <p className={cx("warning")}>
                не является лекарственным средством
              </p>
              {parsedSelftestData.rationItems?.map((rationItem, index) =>
                renderItem(rationItem, index)
              )}
            </>
          )}
        </Screen>
      )}
    </>
  );
};
